let storeContent = utils.generateStore({
	compare_items: [],
	showCompare: false,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchCompareItems(ctx) {
			try {
				ctx.commit(
					'compare_items',
					(await $session.get('compare')) || [],
				);
			} catch (err) {
				throw err;
			}
		},
		async clearCompare(ctx) {
			try {
				ctx.commit('compare_items', []);
				$session.remove('compare');
			} catch (err) {
				throw err;
			}
		},
		async removeCompareItem(ctx, i) {
			try {
				let compare_items = ctx.getters.compare_items;
				compare_items.splice(i, 1);

				ctx.commit('compare_items', compare_items);
				await $session.set('compare', compare_items);
			} catch (err) {
				throw err;
			}
		},
	},
};
